// extracted by mini-css-extract-plugin
export default {"formHeader":"RecoverPasswordForm_formHeader__MbCvX","formBody":"RecoverPasswordForm_formBody__qkrcX"};